import React from 'react';
import styles from './PlatformDetails.module.scss';

import api from '../../helpers/api';
import Loader from '../../components/miscellaneous/Loader/Loader';
import { FaRegCalendarAlt, FaTemperatureHigh, FaEdit } from 'react-icons/fa';
import { AiOutlineHome } from 'react-icons/ai';
import { FiWifi, FiWifiOff } from 'react-icons/fi';
import { MdUpdate } from 'react-icons/md';
import { BsFillKeyFill } from 'react-icons/bs';
import { IoIosUnlock } from 'react-icons/io';
import { $t } from '../../helpers/translator';
import Modal from '../../components/miscellaneous/Modal/Modal';
import PercentageBar from "../../components/miscellaneous/PercentageBar/PercentageBar";
import moment from "moment";
import PlatformUsagePieChart from "../PlatformUsagePieChart/PlatformUsagePieChart";
import ChangePlatformClinic from "../Distributor/ChangePlatformClinic/ChangePlatformClinic";
import MachineActivityStatus from "../Admin/MachineActivityStatus/MachineActivityStatus";
import Timestamp from "../miscellaneous/Timestamp/Timestamp";
import PlatformAdminController from "../PlatformAdminController/PlatformAdminController";
import Tooltip from "../miscellaneous/Tooltip/Tooltip";
import HasPermission from 'helpers/permissions/HasPermission';
import { Link } from "react-router-dom";
import PlatformTimeLimit from '../PlatformTimeLimit/PlatformTimeLimit';
import { setAlert } from "../../store/alerts-slice";
import { connect } from "react-redux";

class PlatformDetails extends React.Component {
    static defaultProps = {
        userType: 2,
        platformId: null,
        header: $t('global.machines.platformDetails')
    }

    constructor(props) {
        super(props);

        this.state = {
            machine: null,
            id: this.props.platformId ? this.props.platformId : null,
            showFirmwareUpdateModal: false,
            showEditPlatformNameModal: false,
            updateHelpRequestedFromService: false,
            detailsLoading: false,
            usageTypeOptions: {},
            platformNewName: '',
            newNameError: '',
            nameChangeLoading: false
        };
    }

    async componentDidMount() {
        if (this.state.id) {
            await this.getBasicData()
            await this.getData();
        }
    }

    async getBasicData() {
        this.setState({ detailsLoading: true }, async () => {
            try {
                // let res = await apy.getPlatform(this.state.id);
                let res = await api.get(`platform/${this.state.id}`);
                console.log('>1', res);
                if (res && res.success) {
                    let machine = res.data.data;
                    machine.id = this.state.id;
                    this.setState({
                        machine: res.data.data,
                        platformNewName: res.data.data.machine_name
                    });
                }
            } catch (e) {
                console.error('err getting single platform', e);
            } finally {
                this.setState({ detailsLoading: false }, () => {
                    // console.log('platff', this.state);
                });
            }
        });
    }

    async getData() {
        this.setState({ detailsLoading: true }, async () => {
            try {
                // let applicatorsRes = await apy.getPlatformApplicators(this.state.id);
                let applicatorsRes = await api.get(`/platform/${this.state.id}/applicators`);
                // console.log('>2', applicatorsRes);
                if (applicatorsRes.data && applicatorsRes.data.success) {
                    this.setState({ applicators: applicatorsRes.data.data });
                }

                // let statisticsRes = await apy.getPlatformUsageStatistics(this.state.id);
                let statisticsRes = await api.get(`platform/${this.state.id}/usage`);
                // console.log('>3', applicatorsRes);
                if (statisticsRes.data && statisticsRes.data.success) {
                    this.setState({ statistics: statisticsRes.data.data }, () => {
                        // console.log('thisst', this.state)
                    });
                }

                let usageRes = await api.get(`platform/statistic?machineId=${this.state.id}`);
                if (usageRes.data && usageRes.data.success) {
                    this.setState({ usage: usageRes.data.data.usage }, () => {
                    });
                }
            } catch (e) {
                console.error('err getting single platform', e);
            } finally {
                this.setState({ detailsLoading: false }, () => {
                    // console.log('platff', this.state);
                });
            }
        });
    }

    closeModals() {
        this.setState({
            showFirmwareUpdateModal: false,
            showEditPlatformNameModal: false,
            platformNewName: this.state.machine.machine_name,
            newNameError: ''
        });
    }

    async contactServiceClickHandler() {
        // console.log('contactServiceClickHandler');
        this.setState({ updateLoading: true }, async () => {
            try {
                // let res = await apy.getPlatformNewVersion(this.state.id);
                await api.post(`/platform/${this.state.id}/newversion`, { machineId: this.state.id });
            } catch (e) {

            } finally {
                this.setState({
                    updateLoading: false,
                    updateHelpRequestedFromService: true
                });
            }
        });
    }

    fieldChangeHandler(e) {
        this.setState({ platformNewName: e.target.value }, () => {
        });
    }

    renderMachineBasicInfo() {
        if (!this.state.machine) {
            return null;
        }
        let machine = this.state.machine;
        machine.online = machine.last_connected && moment().diff(moment(machine.last_connected), 'days') <= 2 ? 1 : 0;
        // console.log(machine)
        // console.log(machine.last_connected, !!machine.last_connected)
        // console.log(moment().diff(moment(machine.last_connected), 'days'))

        return (
            <div className={ `${styles[ 'basic-info-block' ]}` }>
                <div className={ `${styles[ 'machine-name' ]}` }>{ machine.machine_name }</div>
                <div className={ `${styles[ 'machine-id' ]}` }>{ machine.machine_id }</div>
                <div className={ `${styles[ 'machine-img' ]}` }><img src={ machine.img } alt={ machine.machine_name } /></div>
            </div>
        );
    }

    renderMachineExtendedInfo() {
        if (!this.state.machine) {
            return null;
        }
        let machine = this.state.machine;

        return (
            <div className={ `${styles[ 'extended-info-container' ]}` }>
                <div className={ `${styles[ 'extended-info-row' ]}` }>
                    <div className={ `${styles[ 'icon' ]}` }><Tooltip
                        content={ $t('global.machines.temperature') }><FaTemperatureHigh /></Tooltip></div>
                    <div className={ `${styles[ 'value' ]}` }>{ machine.temperature ? machine.temperature : 'N/A' }</div>
                </div>
                <div className={ `${styles[ 'extended-info-row' ]}` }>
                    <div
                        className={ `${styles[ 'icon' ]} ${(machine.online ? styles[ 'green' ] : styles[ 'red' ])}` }>{ machine.online ?
                            <Tooltip content={ $t('global.machines.lastConnection') }><FiWifi /></Tooltip> :
                            <Tooltip content={ $t('global.machines.lastConnection') }><FiWifiOff /></Tooltip> }</div>
                    <div
                        className={ `${styles[ 'value' ]}` }>{ machine.last_connected ?
                            <Timestamp time={ machine.last_connected } /> : 'N/A' }</div>
                </div>
                <div className={ `${styles[ 'extended-info-row' ]}` }>
                    <div className={ `${styles[ 'icon' ]}` }><Tooltip
                        content={ $t('global.machines.connectedToClinic') }><FaRegCalendarAlt /></Tooltip></div>
                    <div className={ `${styles[ 'value' ]}` }>{ machine.connected_to_clinic ?
                        <Timestamp time={ machine.connected_to_clinic } /> : 'N/A' }</div>
                </div>
                <div className={ `${styles[ 'extended-info-row' ]}` }>
                    <div className={ `${styles[ 'icon' ]}` }><Tooltip
                        content={ $t('global.machines.clinicName') }><AiOutlineHome /></Tooltip></div>
                    <div className={ `${styles[ 'value' ]}` }>{ machine.clinic_name ?
                        <div>
                            {
                                this.props.userType > 2 ?
                                    <Tooltip
                                        content={ $t('global.machines.goToClinic') }>
                                        <Link to={ `/clinic/${machine.clinic_id}` }>{ machine.clinic_name }</Link>
                                    </Tooltip>
                                    :
                                    machine.clinic_name
                            }
                        </div>
                        :
                        <div className={ styles[ 'red' ] }>{ $t('global.machines.detached') }</div>}</div>
                        
                </div>
                <div
                    className={ `${styles[ 'extended-info-row' ]} ${(machine.needs_to_update ? styles[ 'red' ] : styles[ 'green' ])}` }>
                    <div className={ `${styles[ 'icon' ]}` }><Tooltip
                        content={ $t('global.machines.versionInfo') }><MdUpdate /></Tooltip></div>
                    <div
                        className={ `${styles[ 'value' ]}` }>{ machine.version } ({ machine.needs_to_update ? $t('global.machines.updateRequired') : $t('global.machines.upToDate') })
                    </div>
                </div>
                <div>
                    { machine.needs_to_update && this.props.userType < 4 ?
                        <div className={ 'alma-danger-button' }
                            onClick={ () => this.setState({ showFirmwareUpdateModal: true }) }
                            style={ { backgroundColor: '#DC3545FF' } }>{ $t('global.machines.getUpdate') }</div>
                        :
                        null }
                </div>
                { machine.machine_type_id === 2 && <>
                    <div
                        className={ `${styles[ 'extended-info-row' ]}` }>
                        <div className={ `${styles[ 'icon' ]}` }><Tooltip
                            content={ $t('global.machines.unlockCode') }>
                            <IoIosUnlock />
                        </Tooltip>
                        </div>
                        <div className={ `${styles[ 'value' ]}` }>
                            { machine.unlock_code }
                        </div>
                    </div>
                    <div
                        className={ `${styles[ 'extended-info-row' ]}` }>
                        <div className={ `${styles[ 'icon' ]}` }><Tooltip
                            content={ $t('global.machines.unlockCode') }>
                            <BsFillKeyFill />
                        </Tooltip>
                        </div>
                        <div className={ `${styles[ 'value' ]}` }>
                            { machine.machine_pin }
                        </div>
                    </div>
                </> }
            </div>
        );
    }

    // renderApplicators() {
    //     if (!this.state.applicators || !this.state.applicators.length) {
    //         return (<div className={`${styles['applicators-container']}`}>{$t('global.machines.noApplicatorsToDisplay')}</div>);
    //     }
    //
    //     return (
    //         <div className={`${styles['applicators-container']}`}>
    //             {this.state.applicators.map((applicator, k) => (
    //                     <div className={`${styles['applicator-container']}`} key={k}>
    //                         <div className={`${styles['applicator-text-SN']}`}>{applicator.serial_number ? applicator.serial_number : 'N/A'}</div>
    //                         <div className={`${styles['applicator-text-1']}`}>{applicator.name}</div>
    //                         <img className={`${styles['applicator-img']}`} src={applicator.image} alt={applicator.name}/>
    //                         <div className={`${styles['applicator-texts']}`}>
    //                             <div className={`${styles['applicator-text-2']}`}>{applicator.handle_id}</div>
    //                             <div className={`${styles['applicator-text-3']}`}>{applicator.pulses} pulses</div>
    //                         </div>
    //                     </div>
    //             ))}
    //         </div>
    //     );
    // }

    renderPercentageBars() {
        return (
            <div className={ `${styles[ 'percentage-bars' ]}` }>
                <PercentageBar styles={ { height: '120px' } }
                    values={ {
                        total: 100,
                        full: this.state.statistics ? this.state.statistics.usage : 0,
                        bottomText: $t('global.machines.usage'),
                        infoText: $t('global.machines.usageExplained'),
                    } }
                    colors={ {
                        colorFull: '#341f97',
                        colorEmpty: 'rgba(52,31,151,0.4)'
                    } } />
                <PercentageBar styles={ { height: '120px' } }
                    values={ {
                        total: 100,
                        full: this.state.statistics ? this.state.statistics.energy_accuracy : 0,
                        bottomText: $t('global.machines.energyAccuracy'),
                        infoText: $t('global.machines.energyAccuracyExplained'),
                    } }
                    colors={ {
                        colorFull: '#319aa1',
                        colorEmpty: 'rgba(49,154,161,0.4)'
                    } } />

                <PercentageBar styles={ { height: '120px' } }
                    values={ {
                        total: 100,
                        full: this.state.statistics ? this.state.statistics.fluence_accuracy : 0,
                        bottomText: $t('global.machines.fluenceAccuracy'),
                        infoText: $t('global.machines.fluenceAccuracyExplained'),
                    } }
                    colors={ {
                        colorFull: '#f7c59f',
                        colorEmpty: 'rgba(247,197,159,0.4)'
                    } } />
            </div>
        );
    }

    renderFirmwareUpdate() {
        return (
            <div>
                <div className={ `${styles[ 'update-header' ]}` }>
                    { $t('global.machines.platformUpdateHeader') }
                </div>

                { this.state.updateHelpRequestedFromService ?
                    <div style={ { textAlign: 'center' } }>
                        <div>{ $t('global.machines.platformUpdateRequested1') }</div>
                        <div>{ $t('global.machines.platformUpdateRequested2') }</div>
                    </div>
                    :
                    <div>
                        { this.state.updateLoading ?
                            <Loader />
                            :
                            <div className={ `${styles[ 'update-text' ]}` }>
                                <div>
                                    {/*{$t('global.machines.platformUpdateHavingTrouble')}*/ }
                                </div>
                                <div>
                                    <span onClick={ async () => {
                                        await this.contactServiceClickHandler();
                                    } }
                                        className={ `${styles[ 'link' ]}` }>{ $t('global.machines.platformUpdateClickHere') }</span> { $t('global.machines.platformUpdateClickHereCont') }
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        );
    }

    renderEditPlatformName() {
        return (
            <div className={ `${styles[ 'edit-platform-name-form' ]}` }>
                <div className={ `${styles[ 'platform-name' ]}` }>{ $t('global.machines.platformName') }</div>
                <input name="staffId"
                    className={ `alma-input ${styles[ 'input-f' ]}` }
                    type="text"
                    value={ this.state.platformNewName }
                    placeholder={ $t('global.staff.enterPlatformName') }
                    onChange={ (e) => this.fieldChangeHandler(e) } />
                <div className={ `${styles[ 'error-text' ]}` }>{ this.state.newNameError }</div>

                <div className={ `${styles[ 'flex-end' ]}` }>
                    <div className={ `alma-button ${styles[ 'alma-button' ]}` }
                        onClick={ async () => await this.editPlatformName() }>{ $t('global.machines.updateName') }</div>
                </div>
            </div>
        );
    }

    async editPlatformName() {
        let error = this.state.newNameError;

        if (!this.state.platformNewName) {
            error = $t('validation.general.required');
        }

        this.setState({ newNameError: error }, async () => {
            if (!error) {
                this.setState({ nameChangeLoading: true }, async () => {
                    try {
                        let payload = {
                            machineId: this.state.id,
                            machineName: this.state.platformNewName
                        };
                        let res = await api.patch(`/platform/${payload.machineId}/name`, payload);

                        await this.getBasicData();
                        this.closeModals();
                    } catch (e) {
                        console.error('err changing platform name', e);
                    } finally {
                        this.setState({ nameChangeLoading: false, platformNewName: this.state.machine.machine_name });
                    }
                });
            } else {
                console.error('errors found');
            }
        });
    }

    getStatHours = (stat) => {
        let times = this.state.usage?.time;
        if (times) {
            if (times[ stat ]) {
                const hours = times[ stat ] / 60 / 60;
                if (hours > 1) {
                    if (hours < 10000) {
                        const hoursTranslation = $t('global.dateTime.hours');
                        return hours.toFixed(2) + ' ' + hoursTranslation;
                    } else {
                        const days = hours / 24;
                        const daysTranslation = $t('global.dateTime.days');
                        return days.toFixed(2) + ' ' + daysTranslation;
                    }
                } else {
                    const minutes = times[ stat ] / 60;
                    if (minutes > 0) {
                        const minutesTranslation = $t('global.dateTime.minutes');
                        return minutes.toFixed(2) + ' ' + minutesTranslation;
                    } else {
                        return $t('global.machines.pieChart.noActivity')
                    }
                }
            }

            return $t('global.machines.pieChart.noActivity')
        }
    }

    getTranslation = (key) => {
        const t = $t(`global.machines.pieChart.${key}`);
        return t.split('/')[ 0 ].split(' + ')[ 0 ];
    }

    editPlatform = async (platform, payload) => {
        try {
            // console.log(payload, this.state.platform.is_unlimited)
            let res = await api.patch(`platform/${platform.id}`, payload);
            // console.log(res)
            if (!res.success) {
                this.props.dispatch(setAlert({ type: 'error' }));
                return;
            }

            console.log(res.data);
            if (res.data?.data?.unlock_code) {
                payload.unlock_code = res.data.data.unlock_code;
            }
            this.setState({
                machine: {
                    ...this.state.machine,
                    ...payload
                }
            });
            this.props.dispatch(setAlert({ type: 'success' }));
        } catch (e) {
            console.error(e);
            this.props.dispatch(setAlert({ type: 'error' }));
        } finally {
        }
    }

    render() {
        let userType = this.props.userType;

        return (
            <div className={ `${styles[ 'container' ]}` }>
                <Modal content={ this.renderFirmwareUpdate() }
                    onClose={ this.closeModals.bind(this) }
                    visible={ this.state.showFirmwareUpdateModal } />

                <Modal content={ this.renderEditPlatformName() }
                    onClose={ this.closeModals.bind(this) }
                    visible={ this.state.showEditPlatformNameModal } />

                <div className={ 'alma-box' }>
                    <div className={ 'alma-box-header' }>
                        <div><h3>{ this.props.header }</h3></div>
                        <HasPermission permission="platform.edit">
                            { userType < 4 ?
                                <div onClick={ () => {
                                    this.setState({ showEditPlatformNameModal: true });
                                } }>
                                    <FaEdit className={ `${styles[ 'edit-button' ]}` } />
                                </div>
                                :
                                <div className={ styles.flexRow }>
                                    <MachineActivityStatus platform={ this.state.machine }
                                        onClose={ async () => await this.getBasicData() }
                                        userType={ this.props.userType }
                                        onChange={ async () => await this.getBasicData() }
                                    />
                                    <ChangePlatformClinic platform={ this.state.machine }
                                        onClose={ async () => await this.getBasicData() }
                                        userType={ this.props.userType }
                                        onChange={ async () => await this.getBasicData() }
                                    />
                                </div>
                            }
                        </HasPermission>

                    </div>
                    { this.state.loading ?
                        <Loader />
                        :
                        <div className={ `${styles[ 'basic-data-container' ]}` }>
                            { this.renderMachineBasicInfo() }
                            <div className={ `d-flex align-items-center ${styles.flexWrap}` }>
                                <div>
                                    { this.state.usage ?
                                        <div className={ styles.usageData }>
                                            <div>
                                                <span>{ this.getTranslation('online') }</span>
                                                <h3 style={ { color: '#473073' } }>{ this.getStatHours('online') }</h3>
                                            </div>
                                            <div>
                                                <span>{ this.getTranslation('treatment') }</span>
                                                <h3 style={ { color: '#319aa1' } }>{ this.getStatHours('treatment') }</h3>
                                            </div>
                                            <div>
                                                <span>{ this.getTranslation('lasing') }</span>
                                                <h3 style={ { color: '#f7c59f' } }>{ this.getStatHours('lasing') }</h3>
                                            </div>

                                        </div>
                                        : <Loader />
                                    }
                                </div>
                                <div>
                                    { this.state.usage && <PlatformUsagePieChart size={ 175 } data={ {
                                        lasing: this.state.usage.percentage.lasing,
                                        treatment: this.state.usage.percentage.treatment,
                                        online: this.state.usage.percentage.online,
                                    } } /> }
                                </div>
                            </div>
                            <div className={ styles.actions }>
                                {
                                    this.props.userType && this.props.userType >= 4 && this.state.machine !== null && this.state.machine.machine_type_id === 2 && <div className={ `${styles[ 'top-center' ]} ${styles[ 'time-limit' ]}` }>
                                        { this.props.userType === 5 && <PlatformTimeLimit platform={ this.state.machine } editPlatform={ this.editPlatform } userType={ 5 } /> }
                                        <PlatformTimeLimit platform={ this.state.machine } editPlatform={ this.editPlatform } userType={ 4 } />
                                    </div>
                                }
                                <div className={ `${styles[ 'top-center' ]}` }>
                                    {
                                        this.props.userType && this.props.userType === 5 && <PlatformAdminController platformId={ this.state.id } />

                                    }
                                </div>
                            </div>
                            { this.props?.userType !== 5 && <div className={ `${styles[ 'top-center' ]}` }>{ this.renderPercentageBars() }</div> }
                            { this.renderMachineExtendedInfo() }

                        </div>
                    }
                </div>

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(PlatformDetails);

